import { useLang } from "@/i18n";

const Row = ({ items }) => (
  <div className="flex shrink-0 items-center">
    {items.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic tracking-tight text-ink/35 md:text-3xl">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rounded-full bg-clay" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="marquee-ribbon"
      aria-label="Garment categories we produce"
      className="overflow-hidden border-y border-ink/10 bg-bone py-6"
    >
      <div className="flex w-max animate-marquee">
        <Row items={t.marquee} />
        <Row items={t.marquee} />
      </div>
    </section>
  );
};

export default Marquee;
